import { type AppFeatureKey } from "utils";

import { type TranslationKey } from "src/types";

export const billingProductFeatureCopy = {
  contentHub: {
    entitlement: "canAccessContentHub",
    titleKey: "billingProductFeatures.contentHub.title",
    descriptionKey: "billingProductFeatures.contentHub.description",
  },
  trainingGroups: {
    entitlement: "canAccessTrainingGroups",
    titleKey: "billingProductFeatures.trainingGroups.title",
    descriptionKey: "billingProductFeatures.trainingGroups.description",
  },
  sellProducts: {
    entitlement: "canSellProducts",
    titleKey: "billingProductFeatures.sellProducts.title",
    descriptionKey: "billingProductFeatures.sellProducts.description",
  },
} as const satisfies Partial<
  Record<
    AppFeatureKey,
    {
      entitlement:
        | "canAccessContentHub"
        | "canAccessTrainingGroups"
        | "canSellProducts";
      titleKey: TranslationKey;
      descriptionKey: TranslationKey;
    }
  >
>;

export type BillingProductFeatureKey = keyof typeof billingProductFeatureCopy;
